<template>
  <div>
    <v-row v-if="!loading">
      <v-col
        v-for="session in sessions"
        :key="session.id"
        cols="12"
        sm="6"
        md="4"
      >
        <chat-session-card :session="session" />
      </v-col>
    </v-row>

    <div v-if="showLoadMore" class="text-center mt-4">
      <v-btn
        text
        color="primary"
        @click="$emit('load-more')"
        :loading="loading"
      >
        Load More
        <v-icon right>mdi-chevron-down</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import ChatSessionCard from './chat-session-card.vue';

export default {
  name: 'ChatSessionList',
  components: {
    ChatSessionCard,
  },
  props: {
    sessions: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    showLoadMore: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
